var map = {
	"./bar-chart-2.png": "16bd",
	"./bar-chart.png": "3caa",
	"./calendar.png": "06de",
	"./clipboard-2.png": "ad0f",
	"./clipboard.png": "d8d4",
	"./file-text.png": "67b4",
	"./globe-2.png": "df9c",
	"./po-monitoring.png": "87d5",
	"./roi.png": "f4a2",
	"./spending-2.png": "3f2f",
	"./spending.png": "d29d",
	"./tool.png": "050d",
	"./tools.png": "5ff3",
	"./trending-up.png": "e78e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7de9";